'use strict';

const PdfPreviewService = require('./PdfPreviewService');

class ManagerPdfPreviewService extends PdfPreviewService {

  constructor(AnalyticsService, Flux) {
    super();
    this.AnalyticsService = AnalyticsService;
    this.Flux = Flux;
  }

  // Get the site from the ManagerStore
  getSite () {
    const ManagerStore = this.Flux.Store.get('ManagerStore');
    return ManagerStore.get('job').site;
  }

  // Returns the current DataCapture obtained from MapStore
  getCurrentDataCapture () {
    const ManagerStore = this.Flux.Store.get('ManagerStore');
    return ManagerStore.get('job').dataCapture;
  }

  // Since there are no map resources on the dataset manager, return an empty
  // array for all of them

  getFormattedAnnotations () {
    return [];
  }

  getFormattedMeasurements () {
    return [];
  }

  getFormattedOverlays () {
    return [];
  }

}

ManagerPdfPreviewService.$inject = ['AnalyticsService', 'sbFlux'];

module.exports = ManagerPdfPreviewService;



// WEBPACK FOOTER //
// ./src/app/shared/pdfPreview/services/ManagerPdfPreviewService.js